import { BaseModel } from "./baseModel";

export class ClipSummaryModel extends BaseModel {
    public clipId:number;
    public clipReference:string;
    public brand:string;
    public seller:string;
    public traceabilityStatus:string;
    public weight:number;
    public baleCount:number;
    public avgMicron:number;
    public avgYield:number;
    public avgSS:number;
}